<template>
  <div id="app">
    <EncartFb></EncartFb>
    <Menu></Menu>
    <!-- <EncartHackathon></EncartHackathon> -->
    <!-- <EncartFormation></EncartFormation> -->
    <!-- <EncartNational></EncartNational> -->
    <EncartFinal></EncartFinal>
    <Projet></Projet>
    <Partenaires></Partenaires>
    <Axes></Axes>
    <Timeline></Timeline>
    <Financement></Financement>
    <Budget></Budget>
    <More></More>
    <Footer></Footer>
  </div>
</template>

<script>
import Menu from './components/Menuv2.vue'
import EncartFb from './components/EncartFb.vue'
import Projet from './components/Projet.vue'
import Budget from './components/Budget.vue'
import Axes from './components/Axes.vue'
import Partenaires from './components/Partenairesv2.vue'
import Timeline from './components/Timelinev2.vue'
import More from './components/More.vue'
import Footer from './components/Footer.vue'
import Financement from './components/Financement.vue'
// import EncartHackathon from './components/EncartHackathon.vue'
// import EncartFormation from './components/EncartFormation.vue'
// import EncartNational from './components/EncartNational.vue'
import EncartFinal from './components/EncartFinal.vue'

export default {
  name: 'app',
  components: {
    Menu,
    EncartFb,
    Projet,
    Axes,
    Partenaires,
    Timeline,
    Financement,
    Budget,
    More,
    Footer,
    // EncartHackathon
    // EncartFormation,
    // EncartNational,
    EncartFinal,
  }
}
</script>

<style lang="scss">
#app {

}
</style>
